import { Logo } from 'components/HeaderNavigation/components/DesktopNavigation/Logo';
import { DictionaryService } from 'service/dictionary/dictionaryService';
import type { DictionaryItem, RecipeResult } from 'types/Recipes';

interface RecipeHeaderPrintProps {
  logo: string;
  recipe?: RecipeResult;
  dictionary?: DictionaryItem[];
}
export const RecipeHeaderPrint = ({ logo, recipe, dictionary }: RecipeHeaderPrintProps) => {
  const TotalTime = recipe?.TotalTimeInMinutes
    ? `${recipe?.TotalTimeInMinutes} ${DictionaryService.getCopy('minutes', dictionary)}`
    : '';
  const PreparationTime = recipe?.PreparationTimeInMinutesSummaryText
    ? `${recipe?.PreparationTimeInMinutesSummaryText}`
    : '';

  const title = recipe?.Title;
  const servings = recipe?.ServingsSummaryText;
  const difficulty = recipe?.Difficulty;
  const preparationTime = TotalTime || PreparationTime;

  const recipeDifficulty: Record<number, string> = {
    0: DictionaryService.getCopy('easy', dictionary),
    1: DictionaryService.getCopy('intermediate', dictionary),
    2: DictionaryService.getCopy('tough', dictionary),
  };

  return (
    <div className="grow flex justify-between flex-col min-h-[100%] min-w-[50%]">
      <div className="w-[80px] flex items-center">
        <Logo src={logo} />
      </div>
      <div className="w-full flex flex-col justify-end">
        <p className="font-bold text-xl">{title}</p>

        {!!preparationTime && (
          <span className="text-sm uppercase">
            {DictionaryService.getCopy('prep', dictionary) || 'preparation'}: {preparationTime}
          </span>
        )}
        {!!recipeDifficulty[difficulty] && (
          <span className="text-sm uppercase">{recipeDifficulty[difficulty]}</span>
        )}
        {!!servings && <span className="text-sm uppercase grow w-full">{servings}</span>}

        <div className="border border-[#E5E2DF] w-[120px]"></div>
      </div>
    </div>
  );
};
